module.exports = __webpack_public_path__ + "static/60import-ff4f4d2acc1e40f1499bc6b485925d45.png";